import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";
import { Input } from "@pjs/core-ui";

angularAMD.component("inputComponent", react2angular(Input, ["autoFocus", "className", "disabled", "id", "inputMode", "placeholder", "onChange", "type", "value"]));
